module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ihxfc"))).then(() => parcelRequire('d0iPb'));